module.exports = __webpack_public_path__ + "img/icon-arrow-right.a6901e2e.svg";